var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.024 10.717-2.116-.242a1.658 1.658 0 0 0-1.367.475l-1.533 1.533a12.538 12.538 0 0 1-5.492-5.491L5.058 5.45c.358-.358.533-.858.475-1.367l-.242-2.1A1.668 1.668 0 0 0 3.633.508H2.19C1.25.508.466 1.292.525 2.233c.441 7.117 6.133 12.8 13.241 13.242.942.058 1.725-.725 1.725-1.667v-1.441a1.652 1.652 0 0 0-1.466-1.65Z",
    fill: "#D2AB67"
  })));
};
export default SvgPhone;